import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Input, Select, message, InputNumber } from "antd";
import { IKnowledge, IKnowledgeForm, IKnowledgeType } from "./types";
import { FormComponentProps } from "antd/lib/form";
import { getDataById, saveOrUpdate, select } from "../actions/dimensionsAndType";
import { Utilitaries } from "../../../business";
import { QmFormLoading } from "../../../components/QmLoading/formLoading";

const { Option } = Select;

const listName = "conhecimentos";

interface IProps extends FormComponentProps {
    record?: IKnowledge;
    onClose: (reload?: boolean) => void;
}

function FormKnowledge({ onClose, record, form }: IProps) {
    const [isSaving, setIsSaving] = useState(false);
    const [KnowledgeTypeList, setKnowledgeTypeList] = useState<IKnowledgeType[]>([]);
    const [loadingTypes, setLoadingTypes] = useState(true);

    const [initialData, setInitialData] = useState<{ loading: boolean; data: IKnowledgeForm | null }>({
        loading: true,
        data: null,
    });

    const { getFieldDecorator } = form;

    useEffect(() => {
        select({
            accao: "lista",
            lista: "tipos_conhecimentos",
            pagina: 1,
            resultados_pagina: 0,
        })
            .then((response) => {
                const list: IKnowledgeType[] = Utilitaries.toArray(response.linha);
                const data = list.map((item) => ({
                    ...item,
                    designacao: typeof item.designacao === "object" ? "" : item.designacao,
                    descricao: typeof item.descricao === "object" ? "" : item.descricao,
                }));
                setKnowledgeTypeList(data);
                setLoadingTypes(false);
            })
            .catch(() => {
                message.error("Erro ao carregar os tipos de conhecimentos");
                onClose();
            });
    }, [onClose]);

    useEffect(() => {
        if (!record) {
            setInitialData((state) => ({
                ...state,
                loading: false,
            }));
            return;
        }

        getDataById(listName, record?.id_conhecimento)
            .then((response) => {
                if (response.conhecimento) {
                    const data = response.conhecimento as IKnowledgeForm;
                    setInitialData({
                        loading: false,
                        data: {
                            ...data,
                            designacao: typeof data.designacao === "object" ? "" : data.designacao,
                            descricao: typeof data.descricao === "object" ? "" : data.descricao,
                            n_inc_cri_neg: typeof data.n_inc_cri_neg === "object" ? "" : data.n_inc_cri_neg,
                            n_inc_cri_posi: typeof data.n_inc_cri_posi === "object" ? "" : data.n_inc_cri_posi,
                            n_sugests: typeof data.n_sugests === "object" ? "" : data.n_sugests,
                        },
                    });
                } else {
                    message.error("Ocorreu um erro");
                    onClose();
                }
            })
            .catch(() => {
                message.error("Ocorreu um erro");
                onClose();
            });
    }, [record, onClose]);

    function handleOk() {
        form.validateFields((err, values) => {
            if (!err) {
                setIsSaving(true);

                const objToSave = { ...values };

                if (record) {
                    objToSave.id_conhecimento = record.id_conhecimento;
                }

                const data = JSON.stringify({
                    conhecimento: {
                        ...objToSave,
                    },
                });

                saveOrUpdate({
                    accao: "guardar",
                    formulario: "qa_conhecimentos.xml",
                    dados: data,
                })
                    .then((sucess) => {
                        if (sucess) {
                            message.success("Guardado");
                            onClose(true);
                        } else {
                            message.error("Ocorreu um erro");
                            setIsSaving(false);
                        }
                    })
                    .catch(() => {
                        message.error("Ocorreu um erro");
                        setIsSaving(false);
                    });
            }
        });
    }

    const isLoadingData = initialData.loading || loadingTypes;

    const customProps = isLoadingData
        ? {
              footer: null,
          }
        : {};

    const formData = initialData.data;

    return (
        <Modal
            style={{ top: 10 }}
            title={record ? "Editar conhecimento" : "Novo conhecimento"}
            visible
            onOk={handleOk}
            onCancel={() => onClose()}
            width="50%"
            confirmLoading={isSaving}
            {...customProps}
        >
            {isLoadingData ? (
                <QmFormLoading />
            ) : (
                <Form layout="vertical" onSubmit={handleOk}>
                    <Row gutter={18}>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Tipo de conhecimento">
                                {getFieldDecorator("tipo_conhecimento", {
                                    initialValue: formData?.tipo_conhecimento,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        allowClear
                                        optionFilterProp="children"
                                        loading={loadingTypes}
                                        filterOption={(input, option) => {
                                            if (option.props.children === undefined || option.props.children === null) {
                                                return false;
                                            }

                                            return (
                                                option.props.children
                                                    .toString()
                                                    ?.toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            );
                                        }}
                                    >
                                        {KnowledgeTypeList.map((item) => (
                                            <Option key={item.id_tipo_conhecimento}>{item.designacao}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Conhecimento">
                                {getFieldDecorator("designacao", {
                                    initialValue: formData?.designacao,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Inc. Nega.">
                                {getFieldDecorator("n_inc_cri_neg", { initialValue: formData?.n_inc_cri_neg })(
                                    <InputNumber min={0} style={{ width: "100%" }} />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Inc. Posi.">
                                {getFieldDecorator("n_inc_cri_posi", { initialValue: formData?.n_inc_cri_posi })(
                                    <InputNumber min={0} style={{ width: "100%" }} />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Sugestões">
                                {getFieldDecorator("n_sugests", { initialValue: formData?.n_sugests })(
                                    <InputNumber min={0} style={{ width: "100%" }} />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}
        </Modal>
    );
}

export const WrappedFormKnowledge = Form.create<IProps>({
    name: "form_Knowledge",
})(FormKnowledge);
